import * as React from 'react';
import {IconButton} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import {GridColDef, GridRenderCellParams} from '@mui/x-data-grid';
import {ServiceRequestDashboardRow} from '../types/service-requests-dashboard.type';

export function useServiceRequestsGroupedColumns(
  baseColumns: GridColDef<ServiceRequestDashboardRow>[],
  openByContractNumber: Record<string, boolean>,
  toggle: (contractId: string) => void,
): GridColDef<ServiceRequestDashboardRow>[] {
  return React.useMemo(() => {
    const expander: GridColDef<ServiceRequestDashboardRow> = {
      field: '__expander__',
      headerName: '',
      width: 58,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      hideable: false,
      resizable: false,
      renderCell: (params: GridRenderCellParams<ServiceRequestDashboardRow>) => {
        const row = params.row;
        if (!row.canToggle) return null;

        const isOpen = row.contractNumber ? openByContractNumber[row.contractRowId] : true;

        const handleToggle = (e: React.MouseEvent<HTMLButtonElement>) => {
          e.stopPropagation();
          if (row.contractNumber) {
            toggle(row.contractRowId);
          }
        };

        return (
          <IconButton size="small" onClick={handleToggle}>
            {isOpen ? <KeyboardArrowDownIcon sx={{color: '#3AC877'}} /> : <KeyboardArrowRight color="info" />}
          </IconButton>
        );
      },
    };

    return [expander, ...baseColumns];
  }, [baseColumns, openByContractNumber, toggle]);
}
